export function getApiErrorMessage(
  error,
  fallback = "The information could not be loaded.",
) {
  if (error?.code === "ERR_CANCELED") {
    return "";
  }

  if (
    error?.code === "ERR_NETWORK" ||
    error?.message === "Network Error" ||
    !error?.response
  ) {
    return "Unable to connect to the server. Check your connection and retry.";
  }

  if (error?.code === "ECONNABORTED") {
    return "The request took too long. Please retry.";
  }

  const status = error?.response?.status;
  const backendMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.errors?.[0];

  if (status === 401 || status === 419 || status === 440) {
    return "Your session has expired. Please sign in again.";
  }

  if (status === 403) {
    return "You do not have permission to view this information.";
  }

  if (status === 404) {
    return backendMessage || "The requested dashboard data was not found.";
  }

  if (status === 408) {
    return "The request timed out. Please retry.";
  }

  if (status === 429) {
    return "Too many requests were sent. The dashboard will retry shortly.";
  }

  if (status >= 500) {
    return (
      backendMessage ||
      "The server could not complete this request. Please retry."
    );
  }

  return backendMessage || fallback;
}